// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2bS0y","label":"Section_label__2UAb4","contentWrap":"Section_contentWrap__m9tIc","footer":"Section_footer__4zjND","footerInner":"Section_footerInner__2QSW9"};